module.exports = __webpack_public_path__ + "media/images/user-activity-log-1fe3941f17a9e259c9145900e7d38647.svg";